import { useStore } from "@nanostores/react"

import { atom } from "nanostores"

const currentScrivitoPage = atom<string | null | undefined>(undefined)

export function useCurrentScrivitoPage() {
  const currentPageObjID = useStore(currentScrivitoPage)

  return { currentPageObjID, set: currentScrivitoPage.set }
}
